import ManageOrders from '@/pages/ManageOrders'

export default {
  path: '/manage/orders',
  name: 'Manage Orders',
  component: ManageOrders
}



// WEBPACK FOOTER //
// ./src/router/manageorders.js